import { Link } from 'react-router-dom';

import type { FC } from 'react';

export const CapabilityColumn: FC = () => (
  <div className="CapabilityColumn">
    <h4>Возможности</h4>
    <ul>
      <li>
        <Link to="/">Онлайн запись</Link>
      </li>
      <li>
        <Link to="/">Универсальный чат</Link>
      </li>
      <li>
        <Link to="/">Журнал записей</Link>
      </li>
      <li>
        <Link to="/">Интеграции</Link>
      </li>
      <li>
        <Link to="/">Рассылки</Link>
      </li>
      <li>
        <Link to="/">Воронки продаж</Link>
      </li>
      <li>
        <Link to="/">Ai-менеджер</Link>
      </li>
      <li>
        <Link to="/">Ai-руководитель</Link>
      </li>
      <li>
        <Link to="/">Сквозная аналитика</Link>
      </li>
      <li>
        <Link to="/">Умный склад</Link>
      </li>
      <li>
        <Link to="/">Система лояльности</Link>
      </li>
      <li>
        <Link to="/">Маркетплейс экспертов</Link>
      </li>
      <li>
        <Link to="/">Задачник</Link>
      </li>
      <li>
        <Link to="/">Финансовая аналитика</Link>
      </li>
      <li>
        <Link to="/">Общая аналитика по сети</Link>
      </li>
      <li>
        <Link to="/">Балансы клиентов</Link>
      </li>
    </ul>
  </div>
);
